import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4764bc96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reaction" }
const _hoisted_2 = { class: "add-emoji-bar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "add-emoji-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_emoji_button = _resolveComponent("emoji-button")!
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_popover = _resolveComponent("f-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiEntries, (emojiEntry) => {
      return (_openBlock(), _createBlock(_component_emoji_button, {
        key: emojiEntry.emojiId,
        emoji: emojiEntry.emojiId,
        count: emojiEntry.emojiItems.length,
        style: _normalizeStyle(_ctx.buttonStyle),
        active: emojiEntry.activeIndex !== -1,
        "emoji-style": _ctx.emojiStyle,
        "count-style": _ctx.countStyle,
        onClick: ($event: any) => (_ctx.handleClickEmojiButton(emojiEntry))
      }, null, 8, ["emoji", "count", "style", "active", "emoji-style", "count-style", "onClick"]))
    }), 128)),
    (!_ctx.readonly && _ctx.availableEmoji.length)
      ? (_openBlock(), _createBlock(_component_f_popover, {
          key: 0,
          visible: _ctx.addEmojiVisible,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addEmojiVisible) = $event)),
          trigger: "click",
          placement: "bottomRight"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEmoji, (emoji) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: emoji,
                  onClick: ($event: any) => (_ctx.handleClickNewEmoji(emoji))
                }, _toDisplayString(emoji), 9, _hoisted_3))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_f_icon, {
                name: "plus-circle",
                size: 16
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}